var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { useMount } from 'react-use';
import cx from 'classnames';
import { Clickable } from './Clickable';
import { Modal } from './ModalMain';
import styles from './Modal.module.less';
/**
 * API 的方式唤起一个确认对话框
 *
 * *异步返回布尔值，为 true 则表示用户确认，为 false 则表示用户取消*
 */
export function confirm(options) {
    return new Promise(function (resolve) {
        var el = document.createElement('div');
        document.body.appendChild(el);
        render(React.createElement(ModalConfirmAPI, __assign({}, options, { onOk: function () { return resolve(true); }, onCancel: function () { return resolve(false); }, onExited: function () {
                var unmounted = unmountComponentAtNode(el);
                if (unmounted && el.parentNode) {
                    el.parentNode.removeChild(el);
                }
            } })), el);
    });
}
export function ModalConfirmAPI(_a) {
    var onOk = _a.onOk, onCancel = _a.onCancel, confirmModalProps = __rest(_a, ["onOk", "onCancel"]);
    var _b = useState(false), visible = _b[0], setVisible = _b[1];
    // 渲染之后，马上显示
    useMount(function () { return setVisible(true); });
    var ok = function () {
        setVisible(false);
        onOk();
    };
    var cancel = function () {
        setVisible(false);
        onCancel();
    };
    return (React.createElement(ModalConfirm, __assign({ visible: visible, onOk: ok, onCancel: cancel, onClose: cancel, maskClosable: true }, confirmModalProps)));
}
/**
 * 确认对话框
 */
export function ModalConfirm(_a) {
    var message = _a.message, onOk = _a.onOk, onCancel = _a.onCancel, _b = _a.okText, okText = _b === void 0 ? '确定' : _b, _c = _a.cancelText, cancelText = _c === void 0 ? '取消' : _c, _d = _a.danger, danger = _d === void 0 ? false : _d, rest = __rest(_a, ["message", "onOk", "onCancel", "okText", "cancelText", "danger"]);
    return (React.createElement(Modal, __assign({}, rest),
        React.createElement("div", { className: styles.modalMain },
            React.createElement("div", { className: styles.modalBody },
                React.createElement("div", { className: styles.modalMessage }, message)),
            React.createElement("div", { className: styles.modalFooter },
                React.createElement(Clickable, { className: styles.modalButton, activeClassName: styles.isActive, onClick: onCancel }, cancelText),
                React.createElement(Clickable, { className: cx(styles.modalButton, danger && styles.danger), activeClassName: styles.isActive, onClick: onOk }, okText)))));
}
